import React, {useState, useEffect} from 'react';
import DateRange from '../../../containers/dashboard/DateRange';
import { httpRequestGet, toaster } from "../../../utils/utils";
import { useDispatch} from 'react-redux';
import apiConstants from '../../../constans/apiConstants';
import DataTable from '../../Table';
const PAN_INSTA_REPORT = () => {
    const [data, setData] = useState([]);
    const [copyData, setcopyData] = useState([])
    const dispatch = useDispatch();

    useEffect(()=>{
        const value=[...data]
        value.forEach(item=>{
            if(item.instaRequired===null){
                item.instaRequired=false
            }
        })
        setcopyData(value)
    }, [data])
    const applyDateRange = (startDate, endDate) => {
        const path = `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/data/panInstaReport/?${'fromDate=' + startDate + '&toDate=' + endDate}`;
        dispatch({ type: 'LOADER_TRUE' });
        httpRequestGet(path).then((res) => {
            dispatch({ type: 'LOADER_FALSE' })
            if (res && res.data) {
                setData(res.data.body.content)
                toaster('success', res.data.message)
            }
        }).catch((err) => {
            dispatch({ type: 'LOADER_FALSE' });
            if (err && err.data) {
                toaster('error', err.data.message)
            }
        });
    }
    return (
        <>
            <div className="date-range">
                <DateRange applyDateRange={applyDateRange} />
            </div>
            {data && data.length > 0 && (
                <div className="proposal-dashboard__table-section downloads-page__table-section">
                    <DataTable
                        cellHeaders={["Proposal No", "Policy No", "PAN Validated", "Insta Eligible", "PAN No", "EKYC Journey", "EKYC Status", "EKYC Error Response Code"]}
                        data={copyData}
                        keys={["proposalNumber", "policyNumber", "panValidated", "instaRequired", "panNumber", "selectedEKycJourney", "selectedEKycJourneyStatus", "responseCode"]}
                        fileName="pan_insta report"
                        addSerialNo={true}
                        convertValueToString={true}
                        showExcelDownload={true}
                        PerPageApiData={false}
                        paginationItems={copyData}
                        alwaysShown={false}
                    />
                </div>
            )}
        </>
    )
}

export default PAN_INSTA_REPORT;
